module.exports = __webpack_public_path__ + "img/logout.32ef3977.svg";